import React, { Component } from 'react';
import { Card, CardBody, FormGroup, Label } from 'reactstrap';
import { Row, Col, PageHeader, Input, Modal, Button, Select, Checkbox, Spin, InputNumber, Image } from 'antd';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { urlapi, token, pathimages, CheckTokenExp } from '../../config';
import 'antd/dist/antd.css';
import { antsStoreData, antsPaymentData, antsRegiatrationData } from "../../@fake-db/sendPage/templateData.js";

class Send extends Component {
    constructor(props) {
        super(props);

        this.LineSendNotify = this.LineSendNotify.bind(this);
        this.RequestTemplate = this.RequestTemplate.bind(this);
        this.onChangeinput = this.onChangeinput.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onCheckMobile = this.onCheckMobile.bind(this);
        this.LineAllSendNotify = this.LineAllSendNotify.bind(this);
        this.onChangeChackbox = this.onChangeChackbox.bind(this);

        this.state = {
            images: "",
            mobile: "",
            templateId: "",
            templist: [],
            errors: "",
            errorMsgMobile: "",
            errorsMsgTemp: "",
            errorsMsgItem: "",
            errorsMsgQt: "",
            loading: false,
            failover: false,
            errorMsg: "",
            data: []
        }
    }

    componentDidMount() {
        this.RequestTemplate();
    }

    LineSendNotify() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true })
            let req = JSON.stringify({
                mobile: this.state.mobile,
                templateId: this.state.templateId,
                failover: this.state.failover === true ? "Y" : "N",
                failoverErrorMsg: this.state.failover === true ? this.state.errorMsg : null,
                data: this.state.data
            });
    
            fetch(urlapi + "api/testNotify", {
                method: 'post',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    // "Authorization": 'Basic ' + btoa(user + ':' + pass)
                    "Authorization": "Bearer " + token
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    mobile: "", errorMsgMobile: "", errorsMsgTemp: "", templateId: "", failover: false, errorMsg: "", images: "", loading: false
                                })
                                if (json.statuscode === "101") {
                                    Modal.success({
                                        content: "Send Line Notify Success",
                                    });
                                } else {
                                    Modal.error({
                                        content: json.description,
                                    });
                                }
                            }.bind(this)
                        );
                    }
                }.bind(this)
            ).catch(function (err) {
                console.log(err)
                this.setState({ mobile: "", errorMsgMobile: "", errorsMsgTemp: "", templateId: "", failover: false, errorMsg: "", images: "", loading: false })
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    LineAllSendNotify() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true })
            let req = JSON.stringify({
                mobile: this.state.mobile,
                templist: this.state.templist,
                failover: this.state.failover === true ? "Y" : "N",
                failoverErrorMsg: this.state.failover === true ? this.state.errorMsg : "",
                data: [antsStoreData, antsPaymentData, antsRegiatrationData]
            });
    
            fetch(urlapi + "line/allnotify", {
                method: 'post',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": 'Basic ' + btoa(user + ':' + pass)
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    mobile: "", errorMsgMobile: "", errorsMsgTemp: "", templateId: "", failover: false, errorMsg: "", images: "", loading: false
                                })
                                if (json.statuscode === "101") {
                                    Modal.success({
                                        content: 'Send line Notify Success',
                                    });
                                } else {
                                    Modal.error({
                                        content: 'json.description',
                                    });
                                }
                            }.bind(this)
                        );
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ mobile: "", errorMsgMobile: "", errorsMsgTemp: "", templateId: "", failover: false, errorMsg: "", images: "", loading: false })
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    RequestTemplate() {
        if (!CheckTokenExp()) {
            fetch(urlapi + "api/Template", {
                method: 'get',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    templist: json
                                });
                            }.bind(this)
                        );
                    }
                }.bind(this)
            ).catch(function () {
                Modal.error({
                    content: 'Error on the internal server.',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    onCancel() {
        this.props.history.push("/dashboard");
    }

    onChangeinput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onChangeSelect(value, e) {
        let img = "";
        let msg = "";
        let templateName = "";
        if (value !== "all" && value !== "") {
            img = this.state.templist.find((item) => item.ltmP_ID === value).ltmP_IMAGE_ID;
            templateName = this.state.templist.find((item) => item.ltmP_ID === value).ltmP_NAME

            if (templateName === "ANTS_STORE") {
                this.setState({ data: antsStoreData })
            } else if (templateName === "ANTS_PAYMENT") {
                this.setState({ data: antsPaymentData })
            } else {
                this.setState({ data: antsRegiatrationData })
            }

            msg = [e.props.name] == "ANTS_STORE" ? "Send Template ANTS_STORE Error" :
                [e.props.name] == "ANTS_PAYMENT" ? "Send Template ANTS_PAYMENT Error" : "Send Template ANTS_REGISTRATION Error"
        } else {
            msg = value == "all" ?
                "Send Template ANTS_STORE Error, Send Template ANTS_PAYMENT Error, Send Template ANTS_REGISTRATION Error"
                : ""
        }

        this.setState({
            templateId: value,
            images: img,
            errorMsg: msg,
            errorsMsgTemp: ""
        });
    }

    onChangeChackbox(e) {
        this.setState({ [e.target.name]: e.target.checked });
    }

    onCheckMobile() {
        let mobileLength = 0;
        let errorMsgMobile = "";
        let errorsMsgTemp = "";
        if (this.state.mobile != "") {
            mobileLength = this.state.mobile.length;
        }

        let temp = this.state.templateId == "" ? true : false;
        let mobile = (mobileLength < 10 && mobileLength > 11) ? true : false;

        if (temp || mobile) {
            if (mobileLength == 0) {
                errorMsgMobile = "Please input your mobile number";
            }
            if (mobile) {
                errorMsgMobile = "Invalid phone number";
            }
            if (temp) {
                errorsMsgTemp = "Please select your template name";
            }

            this.setState({
                errorMsgMobile: errorMsgMobile,
                errorsMsgTemp: errorsMsgTemp,
            })

            return false
        }

        if (this.state.templateId === "all") {
            this.setState({ data: [antsStoreData, antsPaymentData, antsRegiatrationData] })
            this.LineAllSendNotify();
        } else {
            this.LineSendNotify();
        }

    }

    //async foo (){
    //    return "asdasdsdasd"
    //  }

    //let bar = await foo()


    render() {
        const { Option } = Select;
        const { TextArea } = Input;
        const _temp = this.state.templist

        return (
            <div>
                <PageHeader title="LON Quick Send">
                </PageHeader>

                <div className="content">
                    <Spin spinning={this.state.loading}>
                        <Card>
                            <CardBody>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Row gutter={16} type="flex" justify="center">
                                                <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
                                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                                    <FormGroup>
                                                        <Label htmlFor="mobile">
                                                            Mobile
                                                        </Label>
                                                        <Input
                                                            placeholder="Mobile"
                                                            name="mobile"
                                                            onChange={this.onChangeinput}
                                                            value={this.state.mobile}
                                                        />
                                                        <label
                                                            htmlFor={this.state.errorMsgMobile}
                                                            style={{ color: 'red' }}
                                                        >
                                                            {this.state.errorMsgMobile}
                                                        </label>
                                                    </FormGroup>
                                                </Col>
                                                <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Row gutter={16} type="flex" justify="center">
                                                <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
                                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                                    <FormGroup>
                                                        <label htmlFor="template">
                                                            Template Name
                                                        </label>
                                                        <Select
                                                            showSearch
                                                            style={{ width: '100%' }}
                                                            placeholder="Template Name"
                                                            optionFilterProp="children"
                                                            onChange={(value, e) => this.onChangeSelect(value, e)}
                                                            value={this.state.templateId}
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                        >
                                                            <Option value="">เลือก</Option>
                                                            {/* <Option value="all">All Template</Option> */}
                                                            {_temp.map((c, index) => (
                                                                <Option key={index} name={c.ltmP_NAME} value={c.ltmP_ID}>
                                                                    {c.ltmP_NAME}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                        <label
                                                            htmlFor={this.state.errorsMsgTemp}
                                                            style={{ color: 'red' }}
                                                        >
                                                            {this.state.errorsMsgTemp}
                                                        </label>
                                                    </FormGroup>
                                                </Col>
                                                <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row gutter={16}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Row gutter={16} type="flex" justify="center">
                                                <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
                                                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                                    <FormGroup>
                                                        <Checkbox name="failover" checked={this.state.failover} onChange={this.onChangeChackbox}>SMS fail over</Checkbox>
                                                    </FormGroup>
                                                </Col>
                                                <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    {
                                        this.state.failover === true ?
                                            <Row gutter={16}>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Row gutter={16} type="flex" justify="center">
                                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
                                                        <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                                                            <FormGroup>
                                                                <Label htmlFor="errorMsg">
                                                                    Error Message
                                                                </Label>
                                                                <TextArea rows={3}
                                                                    placeholder="Error Message"
                                                                    name="errorMsg"
                                                                    onChange={this.onChangeinput}
                                                                    value={this.state.errorMsg}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            :
                                            null
                                    }
                                    <Row gutter={16}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Row gutter={16} type="flex" justify="end">
                                                <Col xs={24} sm={24} md={24} lg={24} xl={20}></Col>
                                                <Col style={{ textAlign: 'right' }}>
                                                    <Button key="submit" style={{ marginRight: 8 }} onClick={() => this.onCancel()}>
                                                        <span className="fa fa-trash-o"></span> &nbsp;&nbsp;
                                                        Discard
                                                    </Button>
                                                </Col>
                                                <Col style={{ textAlign: 'right' }}>
                                                    <Button type="primary" style={{ marginRight: 8 }} onClick={() => this.onCheckMobile()}>
                                                        <span className="fa fa-paper-plane-o"></span> &nbsp;&nbsp;
                                                        Send
                                                    </Button>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={4}></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <h5>Preview Template</h5>
                                        </Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ overflow: 'auto' }}>
                                            {
                                                this.state.images !== "" ?
                                                    <img src={pathimages + this.state.images}
                                                        style={{ width: 'auto', minHeight: 50, maxHeight: 300 }} />
                                                    :
                                                    <img src={pathimages + "placeholder-image.png"}
                                                        style={{ width: 'auto', minHeight: 50, maxHeight: 300 }} />
                                            }
                                        </Col>
                                    </Row>
                                </Col>

                            </CardBody>
                        </Card>
                    </Spin>
                </div>
            </div>
        );
    }
}

export default Send;


// WEBPACK FOOTER //
// ./src/views/Send/Send.js